import { useEffect } from "react";
import './CardInfo.css';
import Button from "../Button";

function CardInfo({ title, description, images, order, id, icons, textIcons }) {
  useEffect(() => {
    const carousel = document.querySelector(`#${id}`);
    if (carousel && window.bootstrap) {
      new window.bootstrap.Carousel(carousel, { interval: 4000, ride: 'carousel' });
    }
  }, [id]);

  return (
    <div className="card-info-wrapper my-5">
      <div className="row g-0 align-items-center">
        <div className={`col-12 col-lg-5 order-1 order-lg-${order.carousel}`}>
          <div id={id} className="carousel slide custom-carousel" data-bs-ride="carousel">
            <div className="carousel-indicators">
              {images.map((_, index) => (
                <button key={index} type="button" data-bs-target={`#${id}`} data-bs-slide-to={index} className={index === 0 ? "active" : ""} aria-label={`Slide ${index + 1}`} />
              ))}
            </div>
            <div className="carousel-inner h-100">
              {images.map((img, index) => (
                <div key={index} className={`carousel-item h-100 ${index === 0 ? 'active' : ''}`}>
                  <img src={img} className="d-block w-100 h-100 object-fit-cover" alt={`Slide ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div className={`col-12 col-lg-7 order-2 order-lg-${order.text}`}>
          <div className="card-info-content">
            <h3 className="card-title-elegant">{title}</h3>
            <p className="card-desc mt-3">{description}</p>
            
            <div className="row features-icons mt-4 mb-4">
              {icons.map((ico, index) => (
                <div key={index} className="col-4 d-flex flex-column align-items-center text-center">
                  <div className="icon-circle">
                    <i className={ico}></i>
                  </div>
                  <span className="icon-text mt-2">{textIcons[index]}</span>
                </div>
              ))}
            </div>
            
            <div className="mt-auto">
              <Button name="Saiba Mais" rota="contatos" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardInfo;